import { CheckCircle2, Clock, Cpu, Send, AlertTriangle } from 'lucide-react';
import { formatDate } from '../../utils';
import type { ExecutionTimelineEvent } from '../../types';

interface ExecutionTimelineProps {
  events: ExecutionTimelineEvent[];
}

export default function ExecutionTimeline({ events }: ExecutionTimelineProps) {
  const getStageIcon = (stage: ExecutionTimelineEvent['stage']) => {
    switch (stage) {
      case 'received':
        return <Clock className="w-4 h-4 text-blue-500" />;
      case 'calculated':
        return <Cpu className="w-4 h-4 text-purple-500" />;
      case 'dispatching':
        return <Send className="w-4 h-4 text-indigo-500" />;
      case 'executed':
        return <CheckCircle2 className="w-4 h-4 text-emerald-500" />;
      case 'retry':
      case 'failed':
        return <AlertTriangle className="w-4 h-4 text-rose-500" />;
      default:
        return <Clock className="w-4 h-4 text-gray-500" />;
    }
  };

  return (
    <div className="space-y-3">
      <h4 className="text-xs font-semibold text-foreground uppercase tracking-wider">
        Execution Pipeline Progress
      </h4>
      <div className="relative pl-6 space-y-3 before:absolute before:left-2.5 before:top-2 before:bottom-2 before:w-0.5 before:bg-border">
        {events.map(evt => (
          <div key={evt.id} className="relative">
            <div className="absolute -left-[1.35rem] top-0.5 bg-card p-0.5 rounded-full border border-border">
              {getStageIcon(evt.stage)}
            </div>
            <div className="flex items-start justify-between text-xs">
              <div>
                <p className="font-semibold text-foreground capitalize">
                  {evt.stage}: {evt.message}
                </p>
                <p className="text-[10px] text-muted-foreground">
                  {formatDate(evt.timestamp)}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
